<template>
  <div>
    <ValidationObserver ref="pageForm">
      <ValidationProvider v-slot="{ errors }" rules="required">
        <v-text-field
          v-model="name"
          label="Title"
          :error-messages="showValidationErrors ? errors : ''"
        />
      </ValidationProvider>
      <quill-editor
        v-model="content"
        :options="editorOptions"
        class="mt-2"
        ref="quillEditor"
      />
      <div v-if="showContentError" class="text-error">
        Content is required
      </div>
    </ValidationObserver>
  </div>
</template>
['link', 'image']
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { MICROSITE_PAGE_TOOLBAR_OPTIONS } from "@/plugins/v-quill-editor";

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    isUpdate: Boolean,
    micrositePage: Object,
    micrositeId: String,
    displayOrder: Number
  },
  created() {
    if (this.micrositePage) {
      this.adjustPageData();
    }
  },
  data() {
    return {
      name: "",
      content: "",
      showValidationErrors: false,
      editorOptions: {
        modules: {
          toolbar: {
            container: MICROSITE_PAGE_TOOLBAR_OPTIONS
          }
        }
      }
    };
  },
  computed: {
    showContentError() {
      return this.showValidationErrors && !this.content;
    }
  },
  methods: {
    adjustPageData() {
      this.name = this.micrositePage.name;
      this.content = this.micrositePage.content;
    },
    getErrorMessages(errors) {
      return this.showValidationErrors ? errors : "";
    },
    async getPageData() {
      const displayOrder = this.displayOrder;
      return this.isUpdate
        ? {
            ...this.micrositePage,
            name: this.name,
            content: this.content,
            displayOrder
          }
        : {
            name: this.name,
            content: this.content,
            microsite: { id: this.micrositeId },
            isLive: true,
            displayOrder
          };
    },
    async validateForm() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.pageForm.validate();
      if (isValid && this.content) {
        this.showValidationErrors = false;
        const data = await this.getPageData();
        this.$emit("onSubmit", data);
      }
    }
  }
};
</script>
